import { render } from "./ImmaginaHeader.vue?vue&type=template&id=9ccd8642&scoped=true"
import script from "./ImmaginaHeader.vue?vue&type=script&lang=js"
export * from "./ImmaginaHeader.vue?vue&type=script&lang=js"

import "./ImmaginaHeader.vue?vue&type=style&index=0&id=9ccd8642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ccd8642"]])

export default __exports__